import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GraphKonvaComponent} from './app-graph-konva.component'
import {AddStepFormComponent} from './components/add-step-form/add-step-form.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select'
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {MatListModule} from '@angular/material/list'
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {httpLoaderFactory} from '../../app.module';
import {HttpClient} from '@angular/common/http';
import {CdkDrag, CdkDragHandle} from '@angular/cdk/drag-drop';
import {MatChipsModule} from '@angular/material/chips';
import {AttachListFormComponent} from './components/attachments-list-form/attachments-list-form.component';
import {AppGraphSettingsFormComponent} from './components/graph-settings/graph-settings-form.component';
import {ViewImageFormComponent} from './components/image-show-form/image-show-form';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { AppNodeToolbarComponent } from './components/node-toolbar/node-toolbar.component';
import { UsersListComponent } from './components/users-list/users-list.component';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatInputModule,
        ReactiveFormsModule,
        MatToolbarModule,
        MatListModule,
        MatFormFieldModule,
        MatSelectModule,
        MatButtonModule,
        MatTooltipModule,
        MatIconModule,
        MatDialogModule,
        CdkDrag,
        CdkDragHandle,
        MatChipsModule,
        ComponentsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: httpLoaderFactory,
                deps: [HttpClient],
            },
            defaultLanguage: 'ru',
        }),
    ],
    declarations: [
        GraphKonvaComponent,
        AddStepFormComponent,
        AttachListFormComponent,
        ViewImageFormComponent,
        AppGraphSettingsFormComponent,
        AppNodeToolbarComponent,
        UsersListComponent
    ],
    exports: [
        GraphKonvaComponent,
        AddStepFormComponent,
        AttachListFormComponent,
        ViewImageFormComponent,
    ]
})
export class AppGraphKonvaModule {
}
